module.exports = __webpack_public_path__ + "img/imt-main.00b8270e.jpg";